import React from 'react';
import PropTypes from 'prop-types';

const Upi360 = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.3942 13.8835L14.6658 2.76517C14.5695 2.53613 14.4026 2.34382 14.1893 2.21626C13.9761 2.0887 13.7277 2.03255 13.4804 2.05598C13.233 2.07942 12.9996 2.18122 12.8141 2.34655C12.6286 2.51188 12.5008 2.73212 12.4492 2.97517L11.6675 5.55351L10.7108 8.93684L12.3208 12.0635L13.2775 8.66851L13.8725 6.54517L17.8042 14.1518L9.63749 21.7352L10.3842 19.0518L11.6675 14.6885L8.24916 17.7918L7.00082 22.1668L6.14916 25.1768C6.07671 25.4254 6.08898 25.6909 6.18402 25.9317C6.27907 26.1725 6.4515 26.3748 6.67415 26.5068C6.90113 26.6613 7.17531 26.7308 7.44845 26.703C7.7216 26.6753 7.97621 26.5521 8.16749 26.3552L20.1375 15.2835C20.3287 15.1112 20.4576 14.8804 20.504 14.6272C20.5505 14.374 20.5118 14.1125 20.3942 13.8835Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5866 13.0901L13.3232 8.66842L11.6666 5.55342L9.86991 1.97175C9.76411 1.75857 9.59564 1.58284 9.3871 1.46815C9.17857 1.35345 8.93994 1.30528 8.70324 1.33009C8.46352 1.34778 8.23511 1.4391 8.04925 1.59154C7.86339 1.74399 7.72916 1.95012 7.66491 2.18175L1.38824 24.3484C1.31758 24.5941 1.32954 24.8561 1.42228 25.0943C1.51502 25.3325 1.68342 25.5336 1.90158 25.6668C2.12186 25.8076 2.38307 25.8704 2.64329 25.845C2.90351 25.8196 3.14767 25.7075 3.33658 25.5268L6.99991 22.1668L10.3482 19.0634L15.3182 14.5018C15.5141 14.3302 15.6469 14.098 15.6955 13.8421C15.7442 13.5863 15.7058 13.3216 15.5866 13.0901ZM11.6666 14.6884L8.24824 17.7918L4.84158 21.0001L9.13491 5.83342L10.7566 8.93676L12.3666 12.0634L13.0432 13.3818L11.6666 14.6884Z"
      fill={fill || '#6B6C7B'}
    />
    <g clipPath="url(#clip0_5626_41808)">
      <path
        d="M19.8906 15.8667C19.8922 16.3264 19.9498 16.7842 20.0621 17.23H21.8541V14.6084H20.0372C19.9416 15.021 19.8924 15.4431 19.8906 15.8667Z"
        fill={fill || '#6B6C7B'}
      />
      <path
        d="M22.3242 14.6084V17.23H24.1162C24.2332 16.7848 24.2954 16.327 24.3015 15.8667C24.3006 15.4432 24.2524 15.0212 24.1577 14.6084H22.3242Z"
        fill={fill || '#6B6C7B'}
      />
      <path
        d="M22.0888 11.4419C21.2136 11.4419 20.3582 11.7014 19.6305 12.1876C18.9029 12.6738 18.3358 13.3648 18.0009 14.1733C17.666 14.9818 17.5784 15.8715 17.7491 16.7298C17.9198 17.5881 18.3412 18.3765 18.96 18.9953C19.5788 19.6141 20.3672 20.0355 21.2255 20.2063C22.0838 20.377 22.9735 20.2894 23.782 19.9545C24.5905 19.6196 25.2816 19.0525 25.7678 18.3248C26.2539 17.5972 26.5134 16.7417 26.5134 15.8666C26.5134 14.6931 26.0473 13.5676 25.2175 12.7379C24.3877 11.9081 23.2623 11.4419 22.0888 11.4419ZM25.4681 17.7222H24.467C24.2777 18.3148 23.9979 18.8745 23.6374 19.3815C23.3714 19.4974 23.0931 19.5827 22.8078 19.6359C23.3187 19.0807 23.7119 18.4279 23.9637 17.7167H22.3266V19.6939H21.8592V17.7222H20.2138C20.4653 18.4344 20.8585 19.0882 21.3697 19.6442C21.0903 19.5916 20.8176 19.5081 20.5567 19.3953C20.1949 18.8841 19.915 18.3196 19.7271 17.7222H18.7094C18.6211 17.561 18.5443 17.3938 18.4799 17.2216H19.586C19.4824 16.7773 19.4286 16.3228 19.4256 15.8666C19.4258 15.4437 19.4703 15.0219 19.5584 14.6083H18.4273C18.4855 14.4367 18.5557 14.2694 18.6375 14.1078H19.6911C19.8888 13.4493 20.1954 12.8287 20.5982 12.2715C20.8536 12.1657 21.1197 12.0878 21.3919 12.0392C20.8417 12.6297 20.4265 13.3326 20.1751 14.0995H21.8592V11.995H22.3266V14.1078H24.0107C23.7597 13.3422 23.3455 12.6402 22.7967 12.0503C23.0684 12.0954 23.3345 12.1695 23.5904 12.2715C23.9908 12.8246 24.2964 13.4405 24.4947 14.0939H25.5373C25.619 14.2556 25.6893 14.4229 25.7474 14.5945H24.6247C24.7147 15.0125 24.7601 15.439 24.7602 15.8666C24.7587 16.3255 24.7059 16.7828 24.6025 17.2299H25.7087C25.6403 17.3995 25.5599 17.564 25.4681 17.7222Z"
        fill={fill || '#6B6C7B'}
      />
    </g>
    <defs>
      <clipPath id="clip0_5626_41808">
        <rect
          width="9.95556"
          height="9.95556"
          fill="white"
          transform="translate(17.1113 10.8887)"
        />
      </clipPath>
    </defs>
  </svg>
);

Upi360.propTypes = {
  fill: PropTypes.string,
};

export default Upi360;
